import { ApiRecalculateItem, ApiRecalculateRequest } from '../../../api/chats/types/ApiRecalculateRequest'
import { PreviewItem } from './types'
import { getOriginalUnitsOfMeasure } from './PreviewEditsContext'

export function buildRecalculateRequest(items: PreviewItem[]): ApiRecalculateRequest {
  return {
    items: items.map((item): ApiRecalculateItem => {
      switch (item.type) {
        case 'original':
          const { quotedItem } = item.previewItem

          if (quotedItem) {
            return {
              uuid: item.previewItem.uuid,
              sku: quotedItem.sku,
              unitsOfMeasure: item.changedUnitsOfMeasure ?? getOriginalUnitsOfMeasure(quotedItem),
              date: item.changedDate ?? quotedItem.date,
            }
          }

          return {
            uuid: item.previewItem.uuid,
            sku: null,
            unitsOfMeasure: null,
          }
        case 'edited':
          return {
            uuid: item.previewItem.uuid,
            sku: item.catalogItem.sku,
            unitsOfMeasure: item.unitsOfMeasure,
            date: item.date,
          }
        case 'added':
        default:
          return {
            uuid: null,
            sku: item.catalogItem.sku,
            unitsOfMeasure: item.unitsOfMeasure,
            date: item.date,
          }
      }
    }),
  }
}
